import React, { createContext, useContext, useState } from 'react';
import { SVGXMark } from '../components/SVG';

// Create a Context for the modal
const ModalContext = createContext();

let globalShowModal = () => {};
let globalHideModal = () => {};

export const useModal = () => {
    return useContext(ModalContext);
};

export function ModalProvider({ children }) {
    const [modal, setModal] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    const showModal = (content) => {
        setModal(content);
        setIsVisible(true);
    };
    const hideModal = () => {
        setIsVisible(false);
        setTimeout(() => setModal(null), 300); // Match the duration of the slide-down animation
    };

    // Assign to global functions
    globalShowModal = showModal;
    globalHideModal = hideModal;

    const value = { showModal, hideModal };

    return (
        <ModalContext.Provider value={value}>
            <div className={`fixed top-0 left-0 w-full h-dvh z-[100] ${modal ? '' : 'pointer-events-none'}`}>
                <div className={`absolute top-0 left-0 w-full h-full z-[-1] transition-colors duration-300 ${isVisible ? 'bg-black/20' : 'bg-transparent'}`}></div>
                <div className={`absolute bottom-0 left-0 modal-height w-full transition-transform duration-300 ${isVisible ? 'translate-y-0' : 'translate-y-full'}`}>
                    {modal}
                </div>
            </div>
            {children}
        </ModalContext.Provider>
    );
}

// Global utility functions
export const showModal = (content) => globalShowModal(content);
export const hideModal = () => globalHideModal();

export function Modal({ heading = null, isClosable = true, innerClasses = null, children }) {
    return (
        <div className='modal-spacing absolute bottom-0 left-0 bg-white dark:bg-slate-900 h-full w-full rounded-t-3xl'>
            {isClosable ? <button className='absolute flex items-center justify-center w-7 h-7 bg-slate-200 dark:bg-slate-800 top-4 right-4 rounded-full' onClick={hideModal}><SVGXMark classes={'h-5 w-5 fill-slate-700 dark:fill-slate-400'} /></button> : null}
            {heading ? <h2 className='text-xl font-bold text-slate-900 dark:text-white py-4 px-6'>{heading}</h2> : null}
            <div className={`p-4 ${innerClasses}`}>
                {children}
            </div>
        </div>
    );
}